export default String.raw`
.consentsContent label {
    outline-offset: -1px !important;
}

.consentsList, .consentsList li {
    list-style: none;
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    .form__invalid-input {
        position: relative !important;
    }
}

.consentsList {
    .reg-container__required-fields {
        margin: 15px 0 30px 0;
        font-size: 12px;
    }
    ul {
        list-style: none;
    }

    a {
        color: $iconColors;
    }
}

.consents {
    margin: -3px 0 3px 27px;
}

.consents-title {
    margin-bottom: 16px;
}

.consents-wrapper {
    display: flex; 
    flex-direction: column;
    gap: 8px;

    &__statement {
        margin-bottom: 8px;
    }

    &__date {
        display: flex; 
        flex-direction: column;
        gap: 8px;
        label {
            display: block;
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: $labelsColor;
        }
    }

    &__buttons {
        .primary-action-button {
            float: right;
            width: auto;
        }
    }
}

.consents-update {
    width: 700px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .consents-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        overflow: auto;
        max-height: 500px;
        padding-right: 24px;
    }

    .buttons-container {
        display: flex;
        justify-content: flex-end;
        gap: 24px;
    }

    &__rodo {
        @include body-1-regular;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .consent-element {
        padding-bottom: 16px;
    }

    .primary-action-button {
        width: fit-content;
        align-self: end;
    }
}
`